import axios from './axiosConfig'
import type {
  Employee,
  EmployeeCreateRequest,
  EmployeeUpdateRequest,
  EmployeePasswordUpdateRequest,
} from 'Types/Employee'
import type { PaginatedResponse } from 'Types/common'

interface EmployeeListParams {
  page?: number
  limit?: number
  term?: string
  sort_by?: string
  sort_direction?: 'asc' | 'desc'
  filter?: Record<string, unknown>
  employment_status?: string
  can_login?: boolean | string | number
  employee_type?: string
  branch_id?: string
}

export const employeesAPI = {
  getAll: async (params?: EmployeeListParams): Promise<PaginatedResponse<Employee>> => {
    const response = await axios.get('/mcp/employees', { params })
    return response.data
  },

  getById: async (id: number): Promise<Employee> => {
    const response = await axios.get(`/mcp/employees/${id}`)
    const data = response.data?.result?.data ?? response.data?.data ?? response.data
    return data
  },

  create: async (data: EmployeeCreateRequest) => {
    const canLogin = data.can_login === true
    const response = await axios.post('/mcp/employees', {
      name: data.name,
      email: data.email,
      phone: data.phone,
      can_login: canLogin,
      ...(canLogin
        ? {
            password: data.password,
            user_type: data.user_type || 'cashier',
          }
        : {}),
      branch_ids: data.branch_ids,
      employee_type: data.employee_type || 'salary',
      is_active: data.approved ?? 1,
      base_salary: data.base_salary ?? 0,
      commission: data.commission ?? 0,
      bank_transfer: data.bank_transfer ?? 0,
      employment_status: data.employment_status || 'active',
      job_title: data.job_title,
      department: data.department,
      shift_start: data.shift_start,
      shift_end: data.shift_end,
      late_grace_minutes: data.late_grace_minutes,
      late_deduction_per_minute: data.late_deduction_per_minute,
      absence_deduction_amount: data.absence_deduction_amount,
    })
    return response.data
  },

  update: async (id: number, data: EmployeeUpdateRequest) => {
    const response = await axios.put(`/mcp/employees/${id}`, data)
    return response.data
  },

  updatePassword: async (data: EmployeePasswordUpdateRequest) => {
    const response = await axios.put('/mcp/employees/update-password', data)
    return response.data
  },

  block: async (id: number) => {
    const response = await axios.post(`/mcp/employees/block/${id}`)
    return response.data
  },
}
